import Textarea from './Textarea';
import TextareaWithCounter from './TextareaWithCounter/TextareaWithCounter';

export { Textarea, TextareaWithCounter };
export default Textarea;
